import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { SectorInfo } from './shared-constants';
import { from, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SectorsService {
	subscription: Subscription;

	constructor(private db: SpaqFireDb) {}

	addSector(newName: SectorInfo) {
		return from(this.db.pushSector(newName));
	}

	deleteEverything() {
		this.db.removeSector();
	}

	deleteSector(key: string) {
		this.db.removeSector(key);
	}

	hydrate(): Observable<SectorInfo[]> {
		return this.db.sectorsSnapshot$().pipe(map(changes => changes.map((c: any) => ({ key: c.payload.key, ...c.payload.val() }))));
	}

	updateSector(key: string, sector: SectorInfo) {
		this.db.updateSector(key, sector);
	}
}
